/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './exception-image.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../../app/modules/utilities/components/exception-image/exception-image.component';
import * as i3 from '../../../../../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as i4 from '@angular/material';
import * as i5 from '@angular/cdk/platform';
const styles_ExceptionImageComponent:any[] = [i0.styles];
export const RenderType_ExceptionImageComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_ExceptionImageComponent,data:{}});
export function View_ExceptionImageComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),14,'div',[['class',
      'wrapper']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(2,0,(null as any),
          (null as any),9,'button',[['class','mat-icon-button'],['md-icon-button',
              '']],[[8,'disabled',0]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i2.ExceptionImageComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.onClear()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i3.View_MdButton_0,i3.RenderType_MdButton)),i1.ɵdid(3,16384,(null as any),
          0,i4.MdPrefixRejector,[[2,i4.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(4,180224,(null as any),0,i4.MdButton,
          [i1.Renderer2,i1.ElementRef,i5.Platform,i4.FocusOriginMonitor],(null as any),
          (null as any)),i1.ɵdid(5,16384,(null as any),0,i4.MdIconButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted(-1,0,['\n    '])),
      (_l()(),i1.ɵeld(7,0,(null as any),0,3,'md-icon',[['class','mat-icon'],['role',
          'img']],(null as any),(null as any),(null as any),i3.View_MdIcon_0,i3.RenderType_MdIcon)),
      i1.ɵdid(8,16384,(null as any),0,i4.MdPrefixRejector,[[2,i4.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(9,638976,(null as any),
          0,i4.MdIcon,[i1.Renderer2,i1.ElementRef,i4.MdIconRegistry,[8,(null as any)]],
          (null as any),(null as any)),(_l()(),i1.ɵted(-1,0,['clear'])),(_l()(),i1.ɵted(-1,
          0,['\n  '])),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(13,
          0,(null as any),(null as any),0,'img',([] as any[]),[[8,'src',4]],[[(null as any),
              'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i2.ExceptionImageComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.onSelect()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n'])),
      (_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    _ck(_v,9,0);
  },(_ck,_v) => {
    var _co:i2.ExceptionImageComponent = _v.component;
    const currVal_0:any = (i1.ɵnov(_v,4).disabled || (null as any));
    _ck(_v,2,0,currVal_0);
    const currVal_1:any = _co.image.uri;
    _ck(_v,13,0,currVal_1);
  });
}
export function View_ExceptionImageComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-exception-image',
      ([] as any[]),(null as any),(null as any),(null as any),View_ExceptionImageComponent_0,
      RenderType_ExceptionImageComponent)),i1.ɵdid(1,49152,(null as any),0,i2.ExceptionImageComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const ExceptionImageComponentNgFactory:i1.ComponentFactory<i2.ExceptionImageComponent> = i1.ɵccf('app-exception-image',
    i2.ExceptionImageComponent,View_ExceptionImageComponent_Host_0,{image:'image'},
    {clear:'clear',select:'select'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvZG5hdGEtY2VyZi1mcm9udC1lbmQvcmVsZWFzZXMvMjAyMDAzMjYxNjEyMzMvc3JjL2FwcC9tb2R1bGVzL3V0aWxpdGllcy9jb21wb25lbnRzL2V4Y2VwdGlvbi1pbWFnZS9leGNlcHRpb24taW1hZ2UuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3Zhci93d3cvZG5hdGEtY2VyZi1mcm9udC1lbmQvcmVsZWFzZXMvMjAyMDAzMjYxNjEyMzMvc3JjL2FwcC9tb2R1bGVzL3V0aWxpdGllcy9jb21wb25lbnRzL2V4Y2VwdGlvbi1pbWFnZS9leGNlcHRpb24taW1hZ2UuY29tcG9uZW50LnRzIiwibmc6Ly8vdmFyL3d3dy9kbmF0YS1jZXJmLWZyb250LWVuZC9yZWxlYXNlcy8yMDIwMDMyNjE2MTIzMy9zcmMvYXBwL21vZHVsZXMvdXRpbGl0aWVzL2NvbXBvbmVudHMvZXhjZXB0aW9uLWltYWdlL2V4Y2VwdGlvbi1pbWFnZS5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Zhci93d3cvZG5hdGEtY2VyZi1mcm9udC1lbmQvcmVsZWFzZXMvMjAyMDAzMjYxNjEyMzMvc3JjL2FwcC9tb2R1bGVzL3V0aWxpdGllcy9jb21wb25lbnRzL2V4Y2VwdGlvbi1pbWFnZS9leGNlcHRpb24taW1hZ2UuY29tcG9uZW50LnRzLkV4Y2VwdGlvbkltYWdlQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBjbGFzcz1cIndyYXBwZXJcIj5cbiAgPGJ1dHRvbiBtZC1pY29uLWJ1dHRvbiAoY2xpY2spPVwib25DbGVhcigpXCI+XG4gICAgPG1kLWljb24+Y2xlYXI8L21kLWljb24+XG4gIDwvYnV0dG9uPlxuICA8aW1nIFtzcmNdPVwiaW1hZ2UudXJpXCIgKGNsaWNrKT1cIm9uU2VsZWN0KClcIi8+XG48L2Rpdj5cbiIsIjxhcHAtZXhjZXB0aW9uLWltYWdlPjwvYXBwLWV4Y2VwdGlvbi1pbWFnZT4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTtNQUFxQiw0Q0FDbkI7VUFBQTtjQUFBO1lBQUE7WUFBQTtZQUF1QjtjQUFBO2NBQUE7WUFBQTtZQUF2QjtVQUFBLHFEQUFBO1VBQUE7VUFBQSxvQ0FBQTtVQUFBO1VBQUEsc0JBQUE7VUFBQSwyQ0FBMkM7TUFDekM7VUFBQTthQUFBO3VCQUFBLHNDQUFBO1VBQUE7VUFBQSw2QkFBUyxpQ0FBZTtVQUFBLGFBQ2pCLDRDQUNUO1VBQUE7Y0FBQTtZQUFBO1lBQUE7WUFBdUI7Y0FBQTtjQUFBO1lBQUE7WUFBdkI7VUFBQSxnQ0FBNkM7TUFDekM7SUFIRjs7O0lBREY7SUFBQSxXQUFBLFNBQUE7SUFHSztJQUFMLFlBQUssU0FBTDs7OztvQkNKRjtNQUFBO3dDQUFBLFVBQUE7TUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/$$_gendir/app/modules/utilities/components/exception-image/exception-image.component.ngfactory.ts